import * as React from 'react';
import { useState, useEffect } from 'react';
import { StyleSheet, View, Text, Image, Button, TouchableOpacity, ImageBackground, Animated, Easing, Platform, Dimensions } from 'react-native';
import { PropsStackDiscFront, RootStackParamList } from '../../types';
import { themePattern } from '../../constants/pattern';
import { aminoacidos } from '../../assets/aminoacidos';
import { FontAwesome } from '@expo/vector-icons';
import Details from '../../components/Cards/Details';

import BtnCircle from '../../components/buttons/BtnCircle';
import ModelTriAtom from '../../components/Trid/ModelTriAtom';

const { width, height } = Dimensions.get('window')


const backgoundImage = require('./../../assets/backgroud.png');


// Todas as imagens dos aminoacidos
const ala = require('./../../assets/aminoacidos/ala.png');
const arg = require('./../../assets/aminoacidos/arg.png');
const asn = require('./../../assets/aminoacidos/asn.png');
const asp = require('./../../assets/aminoacidos/asp.png');
const cys = require('./../../assets/aminoacidos/cys.png');
const gln = require('./../../assets/aminoacidos/gln.png');
const glu = require('./../../assets/aminoacidos/glu.png');
const gly = require('./../../assets/aminoacidos/gly.png');
const his = require('./../../assets/aminoacidos/his.png');
const ile = require('./../../assets/aminoacidos/ile.png');
const leu = require('./../../assets/aminoacidos/leu.png');
const lys = require('./../../assets/aminoacidos/lys.png');
const met = require('./../../assets/aminoacidos/met.png');
const phe = require('./../../assets/aminoacidos/phe.png');
const pro = require('./../../assets/aminoacidos/pro.png');
const ser = require('./../../assets/aminoacidos/ser.png');
const thr = require('./../../assets/aminoacidos/thr.png');
const trp = require('./../../assets/aminoacidos/trp.png');
const tyr = require('./../../assets/aminoacidos/tyr.png');
const val = require('./../../assets/aminoacidos/val.png');

const imganesAminoacidos = [ala, arg, asn, asp, cys, phe, gly, glu, gln, his, ile, leu, lys, met, pro, ser, tyr, thr, trp, val]

export default function DiscFrontDesktop({ route, navigation }: PropsStackDiscFront) {

  // Controle de parametros de navegação
  let aminoAcid = 0

  if (route.params)
    aminoAcid = route.params.aminoAcid;



  const [count, setCount] = useState(aminoAcid);

  useEffect(() => {
    transitionFade(count)
  });


  // Função Referencia
  let openModalCodon = () => {
    navigation.navigate('DiscBack', { aminoAcid: count }) // open drawer
  };

  let gabarito = require('./../../assets/gabarito.png');
  let alphabase = require('./../../assets/alphabase.png');

  const { name } = aminoacidos(count)


  function next() {
    if (count === 19)
      setCount(0)
    else
      setCount(count + 1)
  }

  function prev() {
    if (count === 0)
      setCount(19)
    else
      setCount(count - 1)
  }

  const [fade, setFade] = useState(new Animated.Value(count));



  function transitionFade(value: number) {
    Animated.sequence([
      Animated.timing(
        fade,
        {
          toValue: 0,
          duration: 0,
          useNativeDriver: false
        }
      ),
      Animated.timing(
        fade,
        {
          toValue: 1,
          delay: 100,
          duration: 200,
          useNativeDriver: false
        }
      ),
    ]).start();
  }


  return (
    <ImageBackground source={backgoundImage} resizeMode="cover" style={{
      flex: 1,
      flexDirection: "column",
      justifyContent: "space-between"
    }}>
      <View style={styles.recuo}>
        <View style={stylesDisc.TitleRecuo}>
        </View>
        <View style={stylesDisc.containerTitle}>
          <View style={stylesDisc.display}>
            <Text style={stylesDisc.title}>{name}</Text>
          </View>
        </View>
        <View style={stylesDisc.TitleRecuo}>
        </View>
      </View>

      <View style={styles.conteudo}>

        <View style={styles.ContainerDetails}>
          <View style={styles.Details}>
            <Details
              aminoAcid={count} />
          </View>
        </View>
        <View style={styles.ContainerDisc}>
          <View style={stylesDisc.virabtn}><BtnCircle
            icon="refresh"
            name={"REPRESENTAÇÃO TABELA DE CÓDON"}
            onPress={() => openModalCodon()}
          /></View>
          <View style={styles.Disc}>

            <View style={styles.Main}>
              <View style={stylesDisc.container}>



                <View style={stylesDisc.containerDisc}>


                  <View style={stylesDisc.imagens}>


                    <Image source={gabarito} style={stylesDisc.gabarito} resizeMode='contain' />
                    <View style={stylesDisc.containerAminoacidoImage}>
                      <Animated.Image source={imganesAminoacidos[count]} style={[stylesDisc.aminoacidoImage, { opacity: fade }]} resizeMode='contain' />

                    </View>
                    <Image source={alphabase} style={stylesDisc.basealpha} resizeMode='contain' />


                  </View>




                  <View style={stylesDisc.containerControl}>
                    <View style={stylesDisc.control}>
                      <TouchableOpacity
                        onPress={() => prev()}
                        style={stylesButton.btn}
                      >
                        <View style={[{ borderTopWidth: 5 }, stylesButton.iconContainer]}>
                          <View style={stylesButton.icon}>
                            <FontAwesome

                              name="arrow-up"
                              style={
                                stylesButton.iconFont
                              }

                            />
                          </View>
                        </View>
                      </TouchableOpacity>
                      <Text>
                        <FontAwesome

                          name="caret-left"
                          style={
                            stylesButton.iconFont
                          }

                        />
                      </Text>
                      <TouchableOpacity
                        onPress={() => next()}
                        style={stylesButton.btn}
                      >
                        <View style={[{ borderBottomWidth: 5 }, stylesButton.iconContainer]}>
                          <View style={stylesButton.icon}>
                            <FontAwesome

                              name="arrow-down"
                              style={
                                stylesButton.iconFont
                              }

                            />
                          </View>
                        </View>
                      </TouchableOpacity>
                    </View>
                  </View>
                </View>


              </View>

            </View>

          </View>
        </View>


        <View style={styles.modelotri}>
          <View
            style={styles.moldeTri}>

            <ModelTriAtom aminoAcid={count} />




          </View>

        </View>

      </View>

      <View style={styles.recuo}>
      </View>



    </ImageBackground>
  );
}
const styles = StyleSheet.create({
  Main: {
    flex: 1,
    padding: 7.5,
  },
  conteudo: {
    flex: 7,
    flexDirection: 'row'
  },
  recuo: {
    flex: 1,
    zIndex: -1,
    flexDirection: "row",
    padding: themePattern.desktop.retreat
  },
  Details: {
    flex: 1
  },
  ContainerDetails: {
    padding: themePattern.desktop.retreat,
    flex: 4,
    justifyContent: 'center',
    flexDirection: 'column'
  },
  moldeTri: {

    backgroundColor: themePattern.desktop.white,
    borderRadius: 10,
    borderStyle: 'solid',
    borderColor: 'black',
    borderWidth: 2,
    flex: 1
  },
  modelotri: {
    padding: themePattern.desktop.retreat,
    flex: 4,
    justifyContent: 'center'

  },
  Disc: {
    flex: 1,
  },
  ContainerDisc: {
    flex: 6,
    justifyContent: "center",
  },
  Buttons: {
    flexDirection: 'row',
    justifyContent: 'space-around',
  }
});

const stylesButton = StyleSheet.create({
  btn: {
    alignItems: "center",
  },
  icon: {
    width: "100%",
    height: "100%",

    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',

    alignItems: "center",

  },
  iconFont: {
    color: themePattern.desktop.white,
    fontSize: 32
  },
  iconContainer: {
    backgroundColor: themePattern.desktop.color1,
    color: themePattern.desktop.white,
    width: 46,
    height: 46,
    borderRadius: 50,

    borderColor: themePattern.desktop.scolor2,
    borderWidth: 1,
  }
});

const stylesDisc = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'column',

  },
  containerTitle: {
    backgroundColor: themePattern.desktop.color1,
    borderRadius: 10,
    padding: 10,
    flex: 1,
    flexDirection: 'column'
  },
  TitleRecuo: {
    flex: 1
  },

  containerDisc: {
    flex: 1,
    flexGrow: 1,
    flexDirection: 'row'
  },

  display: {
    backgroundColor: themePattern.desktop.white,
    padding: 5,
    borderRadius: 10,
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'center',
    alignContent: 'center'
  },
  title: {
    fontSize: themePattern.desktop.title2,
    textAlign: "center",
    fontWeight: 'bold'
  },

  imagens: {
    flexGrow: 1,
    justifyContent: "center",
    alignItems: "center",
    position: "relative"
  },
  gabarito: {
    width: "99%",
    height: "99%",
    position: 'absolute',
    zIndex: 3
  },
  aminoacidos: {
    width: "98%",
    height: "98%",
    position: 'absolute',
    zIndex: 2,
    borderRadius: 50

  },
  containerAminoacidoImage: {
    flexGrow: 1,
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
    width: "100%",
    height: "100%",
    zIndex: 3,

  },
  aminoacidoImage: {
    width: "80%",
    height: "40%",
    right: 40,
    position: 'absolute',
    zIndex: 5
  }
  ,
  basealpha: {
    width: "60%",
    height: "60%",
    position: 'absolute',
    zIndex: 6,
    alignItems:'center'

  },

  containerControl: {
    justifyContent: 'center',
    marginLeft: 10,
    marginRight: 10,
    zIndex: 3
  },
  control: {
    justifyContent: 'space-evenly',
    backgroundColor: themePattern.desktop.color1,
    height: 250,
    padding: 5,
    borderRadius: 10,
  },
  virabtn: {
    height: 'min-height',
    alignItems: 'flex-end',
    width: '100%',
    position: 'absolute',
    bottom: '-70px',
    zIndex: 600
  }
});

